module.exports = __webpack_public_path__ + "static/media/sweet_8.76690567.png";